import React from 'react';
import { FlatTextInput, LargeCloseIcon, ThinSearchIcon } from '@common-fe/common-fe';
import styled from 'styled-components';

import globalTheme from '@/styles/theme';

const Search = styled(FlatTextInput)<{ isActive: boolean }>`
  ${({ isActive, theme }) => {
    if (isActive) {
      return theme.input.focus;
    }

    return '';
  }}
`;

interface Props {
  onClear?: () => void;
  children: string | React.ReactNode;
  isActive: boolean;
  setIsShown: () => void;
  placeholder?: string;
  testId?: string;
  errorText?: string;
}

const FakeSearchInput: React.FC<Props> = ({
  onClear,
  children,
  isActive,
  placeholder,
  setIsShown,
  testId,
  errorText,
}) => {
  if (typeof children === 'object') {
    return children;
  }

  return (
    <Search
      testId={testId}
      value={children as string}
      style={{ width: '320px' }}
      placeholder={placeholder}
      rightIcon={children && onClear ? (
        <LargeCloseIcon
          color="iconPrimary"
          style={{ background: globalTheme.colors.canvas, cursor: 'pointer' }}
          onClick={onClear}
        />
      ) : (
        <ThinSearchIcon
          color="iconPrimary"
          style={{ background: globalTheme.colors.canvas, cursor: 'pointer' }}
          onClick={setIsShown}
        />
      )}
      isActive={isActive}
      {...errorText ? {
        errorText,
        isError: true,
      } : {}}
    />
  );
};

export default FakeSearchInput;
